import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { BlockTypes, DelimiterBlockData } from '../../../../models';
import { DelimiterNodeView } from './DelimiterNodeView';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    delimiterNode: { insertDelimiterNode: ({ style }: DelimiterBlockData) => ReturnType };
  }
}

export const DelimiterNode = Node.create({
  name: 'delimiterNode',
  group: 'block',
  atom: true,
  markdownTokenName: 'hr',

  addAttributes() {
    return { style: '' };
  },

  parseHTML() {
    return [{ tag: BlockTypes.delimiter }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.delimiter, mergeAttributes(HTMLAttributes)];
  },

  parseMarkdown(token, helpers) {
    return helpers.createNode(this.name, { style: 'stars' });
  },

  addCommands() {
    return {
      insertDelimiterNode:
        ({ style }: DelimiterBlockData) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { style } });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(DelimiterNodeView);
  },
});
